export default class GoogleMaps {
    constructor(rootNode, props) {
        this.root = rootNode
        this.mapDom = rootNode.querySelector('.map')
        this.id = this.root.getAttribute('data-id')
        this.key = this.root.getAttribute('data-key')
        this.showMarkerKey = this.root.getAttribute('data-show-marker-key')
        this.map = null
        this.markers = []
        this.config = null

        if (
            !this.mapDom ||
            !this.loadConfig()
        ) {
            return
        }

        this.setTrigger()
    }

    setTrigger() {

        // default via click on the static map image to load the dynamic map
        if (this.config.trigger === undefined || this.config.trigger === 'click') {
            this.mapDom.addEventListener('click', () => {
                this.loadScript()
            })

        // optional scroll (into view) trigger
        } else if (this.config.trigger === 'scroll') {
            // Passive scroll listener, if map is in viewport, trigger loadScript
            window.addEventListener('scroll', () => {
                if (this.isInViewport(this.root) && !this.map) {
                    this.loadScript()
                }
            }, {passive: true});
        }

    }

    isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom - 200 <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    loadScript() {
        const existingScript = document.getElementById('GoogleMapsScript');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key + '&v=weekly';
            script.id = 'GoogleMapsScript';
            document.body.appendChild(script);

            script.onload = () => {
                this.initMap()
            };
        }

        if (existingScript) this.initMap()
    }

    initMap() {
        if (this.config && typeof google !== 'undefined') {
            this.map = new google.maps.Map(this.mapDom, {
                center: {
                    lat: 47,
                    lng: 11
                },
                zoom: 8,
            });

            this.setStyling()
            this.initMarkers()
            this.initBounds()
        }
    }

    setStyling() {
        const style = [ { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "lightness": 20 }, { "weight": "0.64" }, { "color": "#d7bcbd" } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#2b1213" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "administrative.country", "elementType": "labels.text", "stylers": [ { "color": "#c13b3f" } ] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [ { "color": "#986c6e" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#fefbfb" }, { "lightness": 20 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#c5fdce" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#dbd2d2" }, { "lightness": 17 }, { "visibility": "on" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#adc7f5" }, { "lightness": 17 } ] } ];

        this.map.setOptions({styles: style});
    }

    loadConfig() {
        try {
            this.config = eval('config_' + this.id)

            return true
        } catch (e) {
        }
    }

    initMarkers() {
        try {
            this.config.markers.forEach((marker, key) => {
                const label = (this.showMarkerKey) ? key+1 : null;

                const infowindow = new google.maps.InfoWindow({
                    content: marker.title,
                    ariaLabel: marker.title,
                });

                this.markers[key] = new google.maps.Marker({
                    position: marker.position,
                    map: this.map,
                    title: marker.title,
                    label: label ? {text: label.toString(), color: "white"} : null,
                });

                this.markers[key].addListener("click", () => {
                    infowindow.open({
                        anchor: this.markers[key],
                        map: this.map,
                    });
                });
            })

        } catch (e) {
        }
    }

    initBounds() {
        try {
            var bounds = new google.maps.LatLngBounds();

            this.config.markers.forEach((marker) => {
                bounds.extend(marker.position);
            })

            this.map.fitBounds(bounds);
        } catch (e) {
        }
    }
}
